import React from "react";
import { TREATMENT_ICONS, DEFAULT_ICON } from "./treatmentIcons";

// A stored icon value can be EITHER a built-in lucide name (e.g. "Heart")
// or a Font Awesome class string (e.g. "fa-solid fa-brain").
export const isFontAwesome = (v) => typeof v === "string" && v.includes("fa-");

// Renders the correct icon type. For lucide, pass a Tailwind size via `className`.
// For Font Awesome, size is controlled by `faSize` (px).
export const DynamicIcon = ({ name, className = "h-4 w-4", strokeWidth = 1.7, faSize = 16 }) => {
  if (isFontAwesome(name)) {
    return <i className={name} style={{ fontSize: faSize }} aria-hidden="true" />;
  }
  const Ic = TREATMENT_ICONS[name] || TREATMENT_ICONS[DEFAULT_ICON];
  return <Ic className={className} strokeWidth={strokeWidth} />;
};

export default DynamicIcon;
